export default [
    {
        path: 'atendimento-individual',
        component: () => import(
            '@/views/atencao-basica/atendimento-individual/Index'
        ),
        redirect: 'atendimento-individual/index',
        children: [
            {
                name: 'atencao-basica-atendimento-individual',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/atendimento-individual/ListPaciente'
                ),
            },
            {
                name: 'atencao-basica-atendimento-individual-list',
                path: 'list/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/atendimento-individual/List'
                ),
            },
            {
                name: 'atencao-basica-atendimento-individual-create',
                path: 'create/:pacienteId',
                component: () => import(
                    '@/views/atencao-basica/atendimento-individual/Form'
                )
            },
            {
                name: 'atencao-basica-atendimento-individual-edit',
                path: 'edit/:pacienteId/:id',
                component: () => import(
                    '@/views/atencao-basica/atendimento-individual/Form'
                )
            },
        ],
    },
]